/**
 * Created by BFR on 04/05/2017.
 */
define('lisSmpMatDetailView',[
  'module',
  'lisSmpMatCreateEditLayoutView',
  'underscore',
  'marionette',
  'template!lisSmpMatDetailTabTpl',
  'settings'
], function (
  module,
  CreateEditLayoutView,
  _,
  Marionette,
  viewTpl,
  Settings
) {
  'use strict';

  var LisSmpMatDetailView = Marionette.ItemView.extend({
    template: viewTpl,

    modelEvents: {
      change: 'render'
    },

    events: {
      'click .js-edit': '_onEdit'
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.viewLess = this.model.get('secId');
      templateData.currentCAccountSecId = Settings.get('currentCAccount').secId;
      return templateData;
    },

    _onEdit: function() {
      var createEditView = new CreateEditLayoutView({
        lisSmpMatModel: this.model
      });
      createEditView.show({
        title: _.i18n('lissmpmat.edit')
      });
    }

  });

  module.exports = LisSmpMatDetailView;
});
